import * as yup from 'yup';
import { fundUnitsReportReconcileFormFields } from '../../fields/formFields/fundUnitsReportReconcile';

export const fundUnitsReportReconcileFormSchema = yup.object({
  [fundUnitsReportReconcileFormFields.reconciledExternal]: yup.number().min(0),
});
